import { strings } from '@/shared/strings';
import { WidgetBoard } from '@/features/dashboard/WidgetBoard';

/**
 * Overview. Section 5.2.
 *
 * Live work in progress with running clocks, stage load, the attention list and
 * range tabs. The order is the client's priority. What is happening right now
 * comes before what needs deciding, which comes before the line, which comes
 * before the numbers. A manager opening this on a wall display reads down it.
 *
 * Since the lab's request of 12 October 2026 it is a screen of widgets, as the
 * Dashboard is, and its reader's to arrange: "Admin dashboard stays this by
 * default, but enable customization". So it comes exactly as it always has,
 * the same sections in the same order, each now a widget (`FloorWidgets`), and
 * Customize at its top takes any of them off, moves them, and adds whatever
 * else its reader may see: the cases due today, what the lab is owed.
 *
 * What each section is sent is no longer decided here. A widget is offered to
 * a reader the server answers (`mayShowWidget`): the sales to a holder of
 * Reports who is sent money, the team to a holder of Staff productivity.
 */
export function OverviewScreen() {
  return <WidgetBoard screen="overview" label={strings.overview.label} title={strings.overview.title} />;
}
